import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Components/Api/Api";
import ReactPlayer from "react-player";
import VideoModal from "../Components/Videos/VideoModal";
import { fetchData } from "../../Cpanel/Components/Utilities";
import Helmet from "../Components/Helment";

const Tutorial = () => {
  const [showModal, setShowModal] = useState(false);
  const [video, setVideo] = useState(null);
  const handleShow = (video) => {
    setVideo(video);
    setTimeout(() => {
      setShowModal(true);
    }, 0);
  };
  const handleClose = () => setShowModal(false);
  const [playing, setPlaying] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredVideos, setFilteredVideos] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [positionFirstVideos, setPositionFirstVideos] = useState([]);
  const [positionSecondVideos, setPositionSecondVideos] = useState([]);
  const [positionThirdVideos, setPositionThirdVideos] = useState([]);
  const [positionFourthVideos, setPositionFourthVidoes] = useState([]);

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("catid", 1);
    fetchData("getvideo", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    const firstvideos = data?.dt?.filter((video) => video.position === 1);
    const secondvideos = data?.dt?.filter((video) => video.position === 2);
    const thirdvideos = data?.dt?.filter((video) => video.position === 0)[0];
    const fourthvideos = data?.dt?.filter((video) => video.position === 22);
    setPositionFirstVideos(firstvideos);
    setPositionSecondVideos(secondvideos);
    setPositionThirdVideos(thirdvideos);
    setPositionFourthVidoes(fourthvideos);
  };

  const searchRequest = async (e) => {
    const bodyFormData = new FormData();
    // bodyFormData.append('guid', Cookies.get("guid"))
    // bodyFormData.append('pageNo', lazyState?.page + 1 ?? 1)
    // bodyFormData.append('pageSize', lazyState?.rows ?? 20)
    bodyFormData.append("srch", e);
    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "getvideo",
        },
      });
      if (response.status === 200) {
        const data = await response;
        setFilteredVideos(data?.data?.dt);

        // setPositionSecondVideos()
        // setPositionThirdVideos()
      } else {
        console.error(`API request failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleSearch = (e) => {
    searchRequest(e);
    setSearchValue(e);
  };
  const handleOpenModal = () => {
    console.log("open modal");
  };

  function formatTime(seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = seconds % 60;

    // Add leading zero if less than 10
    var formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    var formattedSeconds =
      remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;

    return formattedMinutes + ":" + formattedSeconds;
  }
  const videoUrl = "https://www.aparat.com/etc/api/video/videohash/rzKus"; // Replace with your video URL
  return (
    <Helmet title="آموزش">
      <div className={"container  p-4"}>
        <div className="turorial-header panel-header">
          <div className="row">
            <div className="col-12 col-lg-4">
              <h3>فیلم های آموزشی</h3>
            </div>
            <div className="col-12 col-lg-4"></div>
            <div className="col-12 col-lg-4">
              <div className="d-flex align-items-center gap-3">
                <div className="search-badge">
                  {searchValue && (
                    <div className="d-flex align-items-center btn btn-sm btn-outline-secondary border-none rounded ">
                      <FontAwesomeIcon
                        className="search-result-icon"
                        size={"1"}
                        icon="close"
                        onClick={() => setSearchValue("")}
                      />
                      <label>{searchValue}</label>
                    </div>
                  )}
                </div>
                <div className="tutorial-search-box">
                  <input
                    type={"text"}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch(searchTerm);
                      }
                    }}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <FontAwesomeIcon
                    icon="search"
                    className="search-icon"
                    onClick={() => handleSearch(searchTerm)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {searchValue && (
            <div className="tutorial-top-section ">
              <VideoModal
                showModal={showModal}
                handleClose={handleClose}
                videoUrl={video?.url}
                Title={video?.title}
              />
              <div className="row">
                {filteredVideos?.map((video) => (
                  <div className="col-12 col-lg-3 mt-5" key={video?.vid}>
                    <div className="video-card">
                      <div className="video-section">
                        <img
                          alt={"video title"}
                          className="video-card-video"
                          src={`https://api.taab30.com${video?.thumbnail}`}
                        />
                        <div className="video-player-btn">
                          <FontAwesomeIcon
                            icon={`${showModal ? "pause" : "play"}`}
                            onClick={() => handleShow(video)}
                          />
                        </div>
                      </div>
                      <div className="video-body-section">
                        <div className="d-flex flex-column">
                          <div className="d-flex flex-row justify-content-between p-2">
                            <div>
                              <p>{video?.title}</p>
                            </div>
                            <div>
                              <span>{formatTime(video?.duration)}</span>
                            </div>
                          </div>
                          {/*<div*/}
                          {/*    className='d-flex flex-row justify-content-between p-2'>*/}
                          {/*    <div><p>بیمه عمر</p></div>*/}
                          {/*    <div><span>02:10</span></div>*/}
                          {/*</div>*/}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {!searchValue && (
            <div>
              <div className="tutorial-top-section ">
                <VideoModal
                  showModal={showModal}
                  handleClose={handleClose}
                  videoUrl={video?.url}
                  Title={video?.title}
                  id={video?.vid}
                />
                <div className="row">
                  {positionFirstVideos?.map((video) => (
                    <div className="col-12 col-lg-3 mt-5" key={video?.vid}>
                      <div className="video-card">
                        <div className="video-section">
                          <img
                            alt={"video title"}
                            className="video-card-video"
                            src={`https://api.taab30.com${video?.thumbnail}`}
                          />
                          <div className="video-player-btn">
                            <FontAwesomeIcon
                              icon={`${showModal ? "pause" : "play"}`}
                              onClick={() => handleShow(video)}
                            />
                          </div>
                        </div>
                        <div className="video-body-section">
                          <div className="d-flex flex-column">
                            <div className="d-flex flex-row justify-content-between p-2">
                              <div>
                                <p>{video?.title}</p>
                              </div>
                              <div>
                                <span>{formatTime(video?.duration)}</span>
                              </div>
                            </div>
                            {/*<div*/}
                            {/*    className='d-flex flex-row justify-content-between p-2'>*/}
                            {/*    <div><p>بیمه عمر</p></div>*/}
                            {/*    <div><span>02:10</span></div>*/}
                            {/*</div>*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="row ">
                <div className="col-12 col-lg-6 m-auto main-video">
                  <div className="m-auto  text-center">
                    {positionThirdVideos?.url && (
                      <ReactPlayer
                        width={"100%"}
                        height={"100%"}
                        // class={'m-auto'}
                        url={`https://api.taab30.com${positionThirdVideos?.url}`}
                        controls
                        playsinline
                      />
                    )}
                    {/*<div className='video-section'>*/}
                    {/*    <img alt={'video title'}*/}
                    {/*         className='video-card-video'*/}
                    {/*         src={CoverImage}/>*/}
                    {/*    <div*/}
                    {/*        className='video-player-btn'>*/}
                    {/*        <FontAwesomeIcon*/}
                    {/*            icon={`${showModal ? 'pause' : 'play'}`}*/}
                    {/*            onClick={() => setShowMainVideo(video)}/>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*{showMainVideo && positionThirdVideos?.url &&*/}
                    {/*    <video width="100%" height="100%"*/}
                    {/*           controls playsInline>*/}
                    {/*        <source*/}
                    {/*            src={`https://api.taab30.com${positionThirdVideos?.url.replace("\\", "/")}`}*/}
                    {/*            type="video/mp4"/>*/}
                    {/*    </video>*/}
                    {/*}*/}
                  </div>
                  <div className="d-flex flex-row justify-content-around  align-items-center">
                    <div>
                      <h4>{positionThirdVideos?.title} </h4>
                    </div>
                    <div>{formatTime(positionThirdVideos?.duration)}</div>
                  </div>
                </div>
              </div>

              <div className="tutorial-top-section">
                <div className="row ">
                  {positionSecondVideos?.map((video) => (
                    <div className="col-12 col-lg-3 mt-5" key={video?.vid}>
                      <div className="video-card">
                        <div className="video-section">
                          <img
                            alt={"video title"}
                            className="video-card-video"
                            src={`https://api.taab30.com${video?.thumbnail}`}
                          />
                          <div className="video-player-btn">
                            <FontAwesomeIcon
                              icon={`${showModal ? "pause" : "play"}`}
                              onClick={() => handleShow(video)}
                            />
                          </div>
                        </div>
                        <div className="video-body-section">
                          <div className="d-flex flex-column">
                            <div className="d-flex flex-row justify-content-between p-2">
                              <div>
                                <p>{video?.title}</p>
                              </div>
                              <div>
                                <span>{formatTime(video?.duration)}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="tutorial-top-section">
                <div className="row ">
                  {positionFourthVideos?.map((video) => (
                    <div className="col-12 col-lg-3 mt-5" key={video?.vid}>
                      <div className="video-card">
                        <div className="video-section">
                          <img
                            alt={"video title"}
                            className="video-card-video"
                            src={`https://api.taab30.com${video?.thumbnail}`}
                          />
                          <div className="video-player-btn">
                            <FontAwesomeIcon
                              icon={`${showModal ? "pause" : "play"}`}
                              onClick={() => handleShow(video)}
                            />
                          </div>
                        </div>
                        <div className="video-body-section">
                          <div className="d-flex flex-column">
                            <div className="d-flex flex-row justify-content-between p-2">
                              <div>
                                <p>{video?.title}</p>
                              </div>
                              <div>
                                <span>{formatTime(video?.duration)}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {searchValue && !filteredVideos.length && (
            <div>جستجو نتیجه ای نداشت</div>
          )}
        </div>
      </div>
    </Helmet>
  );
};

export default Tutorial;
